import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-interest-selector',
  templateUrl: './interest-selector.component.html',
  styleUrls: ['./interest-selector.component.scss']
})
export class InterestSelectorComponent {
  @Input()
  public interests: Array<{ name: string; type: string; selected: boolean }>;

  @Input()
  public mode: string = 'default';

  @Output()
  public remove: EventEmitter<any> = new EventEmitter();

  @Output()
  public selectedInterests: EventEmitter<Array<{ name: string; selected: boolean }>> = new EventEmitter<Array<{ name: string; selected: boolean }>>();

  public changeSelected($event, interest): void {
    if (this.mode === 'default') {
      interest.selected = $event.selected;
      this.selectedInterests.emit(this.interests);
    }
  }

  public handleChipClick(event): void {
    if (this.mode === 'filter') {
      this.remove.emit(event);
    }
  }
}
